<div class="mb-3 password-field w-100" [ngClass]="containerClass">
  <label [for]="inputId" class="form-label" [ngClass]="labelClass">{{ label }}</label>

  <div
    class="input-group"
    [ngClass]="[
      inputClass,
      control?.touched && control?.errors ? 'is-invalid' : ''
    ]"
  >
    <span class="input-group-text">
      <i class="bi bi-lock"></i>
    </span>

    <input
      [id]="inputId"
      class="form-control"
      [ngClass]="inputClass"
      [placeholder]="placeholder || label"
      [type]="showPassword ? 'text' : 'password'"
      [value]="value"
      (input)="setValue($any($event.target).value)"
      (blur)="markMainTouched()"
      [class.with-toggle]="value?.length"
    />

    <span class="input-group-text" *ngIf="value">
      <button
        type="button"
        class="btn reset btn-toggle"
        (click)="togglePassword()"
        [attr.aria-label]="showPassword ? 'Hide password' : 'Show password'"
        [attr.title]="showPassword ? 'Hide password' : 'Show password'"
      >
        <i class="bi" aria-hidden="true" [ngClass]="showPassword ? 'bi-eye' : 'bi-eye-slash'"></i>
      </button>
    </span>
  </div>

  <div *ngIf="control?.touched && control?.errors?.['required']" class="text-danger small mt-1">
    Password is required.
  </div>

  <!-- Criteria-based strength and checks -->
  <div class="criteria mb-3" *ngIf="validateCriteria && value?.length">
    <div class="progress mt-2">
      <div
        class="progress-bar"
        role="progressbar"
        [style.width.%]="strengthPercent"
        [ngClass]="strengthClass.replace('text-', 'bg-') + ' ' + strengthBarClass"
      ></div>
    </div>
    <div class="strength-label justify-content-between align-items-center mt-3 mb-1">
      <span class="text-muted">Strength: </span>
      <span class="fw-semibold text-capitalize" [class]="strengthClass">{{ strengthLabel }}</span>
    </div>
    <div class="criteria-list mt-4">
      <div class="mb-2 fw-semibold">Password must have:</div>
      <div class="criteria-list-items text-muted small">
        <div class="criteria-item" [class.valid]="criteria.minLength">
          <i
            class="bi"
            [ngClass]="criteria.minLength ? 'bi-check-circle text-success' : 'bi-circle'"
          ></i>
          At least 8 characters
        </div>
        <div class="criteria-item" [class.valid]="criteria.number">
          <i
            class="bi"
            [ngClass]="criteria.number ? 'bi-check-circle text-success' : 'bi-circle'"
          ></i>
          At least one number
        </div>
        <div class="criteria-item" [class.valid]="criteria.upperLower">
          <i
            class="bi"
            [ngClass]="criteria.upperLower ? 'bi-check-circle text-success' : 'bi-circle'"
          ></i>
          Uppercase and lowercase
        </div>
        <div class="criteria-item" [class.valid]="criteria.special">
          <i
            class="bi"
            [ngClass]="criteria.special ? 'bi-check-circle text-success' : 'bi-circle'"
          ></i>
          At least one special character
        </div>
      </div>
    </div>
  </div>

  <!-- Confirm Password -->
  <div *ngIf="confirm" class="mb-3">
    <label for="confirmPassword" class="form-label" [ngClass]="labelClass">
      {{ confirmLabel }}
    </label>

    <div
      class="input-group"
      [ngClass]="[
        confirmInputClass,
        confirmTouched && confirmValue !== passwordValue
          ? 'is-invalid'
          : ''
      ]"
    >
      <span class="input-group-text">
        <i class="bi bi-lock"></i>
      </span>

      <input
        id="confirmPassword"
        class="form-control"
        [ngClass]="confirmInputClass"
        [placeholder]="confirmPlaceholder"
        [type]="showConfirm ? 'text' : 'password'"
        [(ngModel)]="confirmValue"
        (ngModelChange)="markConfirmTouched()"
        [class.with-toggle]="confirmValue?.length"
      />

      <span class="input-group-text" *ngIf="confirmValue">
        <button
          type="button"
          class="btn reset btn-toggle"
          (click)="toggleConfirm()"
          [attr.aria-label]="showConfirm ? 'Hide password' : 'Show password'"
          [attr.title]="showConfirm ? 'Hide password' : 'Show password'"
        >
          <i class="bi" [ngClass]="showConfirm ? 'bi-eye' : 'bi-eye-slash'" aria-hidden="true"></i>
        </button>
      </span>
    </div>

    <div *ngIf="confirmValue !== passwordValue" class="text-danger small mt-1">
      Passwords must match exactly.
    </div>
  </div>
</div>
